
import { BookOpen, Building, GraduationCap, NetworkIcon, Briefcase, Users, FileSpreadsheet } from "lucide-react";

export interface Repository {
  name: string;
  manager: string;
  role: string;
  usages: {
    title: string;
    items: string[];
  }[];
  icon: any;
}

export const repositories: Repository[] = [
  {
    name: "RNCP",
    manager: "France Compétences",
    role: "Il recense tous les diplômes, titres et certifications reconnus par l'État. Chaque certification est décomposée en blocs de compétences, ce qui permet de comprendre précisément ce qu'un candidat maîtrise après sa formation.",
    usages: [
      {
        title: "Usages",
        items: [
          "Candidats : Vérifiez les certifications adaptées à vos projets de carrière.",
          "Employeurs : Analysez les compétences associées à chaque certification pour mieux recruter.",
          "Organismes de formation : Structurez vos parcours autour de blocs de compétences reconnus."
        ]
      }
    ],
    icon: GraduationCap
  },
  {
    name: "ROME",
    manager: "Pôle Emploi",
    role: "Il classe les métiers et emplois par fiches détaillant les missions, les compétences requises et les conditions de travail. Il facilite la correspondance entre candidats et offres d'emploi.",
    usages: [
      {
        title: "Usages",
        items: [
          "Demandeurs d'emploi : Identifiez les métiers qui correspondent à vos compétences.",
          "Employeurs : Rédigez vos offres d'emploi en vous basant sur des fiches métiers fiables.",
          "Conseillers RH : Orientez les candidats vers des postes adaptés à leurs expériences."
        ]
      }
    ],
    icon: Briefcase
  },
  {
    name: "RIME",
    manager: "DGAFP",
    role: "Ce répertoire décrit les métiers de la fonction publique d'État. Il reste plus complet et détaillé que son successeur, le RMFP, encore en déploiement.",
    usages: [
      {
        title: "Usages",
        items: [
          "Agents publics : Comprenez les missions et compétences attendues pour votre poste ou un poste ciblé.",
          "Ressources humaines : Gérez les parcours professionnels et les mobilités internes."
        ]
      }
    ],
    icon: Building
  },
  {
    name: "RMFP",
    manager: "DGAFP",
    role: "Ce référentiel remplace progressivement le RIME pour offrir une description standardisée des métiers des trois versants de la fonction publique (État, territoriale et hospitalière).",
    usages: [
      {
        title: "Usages",
        items: [
          "Agents et gestionnaires RH : Favorisez la mobilité inter-fonctions publiques et harmonisez les plans de carrière.",
          "Organismes de formation : Alignez les parcours sur les métiers cibles de la fonction publique."
        ]
      }
    ],
    icon: NetworkIcon
  },
  {
    name: "Référens III",
    manager: "Ministère de l'Enseignement Supérieur et de la Recherche",
    role: "Décrire les métiers des ingénieurs et personnels techniques (ITRF et ITA) au sein de l'enseignement supérieur et de la recherche. Ce référentiel regroupe 242 emplois-types répartis en 8 branches d'activités professionnelles.",
    usages: [
      {
        title: "Usages",
        items: [
          "Personnels de l'enseignement et de la recherche : Identifiez les compétences nécessaires pour chaque emploi-type.",
          "RH et gestionnaires de carrière : Organisez les mobilités et planifiez les formations."
        ]
      }
    ],
    icon: BookOpen
  },
  {
    name: "REME",
    manager: "Ministère de l'Enseignement Supérieur, de la Recherche et de l'Innovation",
    role: "Compléter Référens III en couvrant un plus large éventail de métiers au sein du ministère. Il regroupe 105 emplois-types organisés en 13 familles professionnelles.",
    usages: [
      {
        title: "Usages",
        items: [
          "Agents du ministère : Accédez aux descriptions de métiers pour préparer vos mobilités ou évolutions de carrière.",
          "Services RH : Simplifiez la gestion des carrières en harmonisant les référentiels métiers."
        ]
      }
    ],
    icon: Users
  },
  {
    name: "DICo",
    manager: "DGAFP",
    role: "Compléter les référentiels métiers en définissant les compétences génériques (savoir-faire, savoir-être, domaines de connaissance).",
    usages: [
      {
        title: "Usages",
        items: [
          "Agents : Identifiez les compétences transversales à développer pour évoluer.",
          "RH : Facilitez la création de fiches de poste cohérentes et l'évaluation des compétences."
        ]
      }
    ],
    icon: FileSpreadsheet
  }
];
